import { resetStore } from "../redux/store";

function deleteAllCookies() {
  const cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.slice(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
  }
}
function handleUserChange() {
  try {
    resetStore();
    // Additional cleanup if needed
  } catch (error) {
    console.error("Failed to reset store:", error);
  }
}
export const handleLogoutFromSystem = (setAuthStep, logout) => {
  setAuthStep(0);
  deleteAllCookies();
  localStorage.clear();
  handleUserChange();
  logout && logout()
};
